const ID_TOKEN_KEY = 'id_token'
const USER_DATA = 'user_data'
const USER_LANG = 'user_lang'

const JwtService = {
  getToken: () => {
    const token = window.localStorage.getItem(ID_TOKEN_KEY)
    return token
  },
  getUserData: () => {
    const userData = window.localStorage.getItem(USER_DATA)
    return JSON.parse(userData)
  },
  saveAuthData: (token, userData) => {
    if (token) window.localStorage.setItem(ID_TOKEN_KEY, token)
    if (userData) {
      window.localStorage.setItem(USER_DATA, JSON.stringify(userData))
      if (userData.userSettings) {
        const languageSettings = userData.userSettings.filter(s => s.key === 'Language')
        if (languageSettings.length > 0) {
          window.localStorage.setItem(USER_LANG, languageSettings[0].value)
        }
      }
    }
  },
  destroyAuthData: () => {
    window.localStorage.removeItem(ID_TOKEN_KEY)
    window.localStorage.removeItem(USER_DATA)
  }
}

export default JwtService
